/**
 * Enumerated type for the inventory regularization.
 */
export const FormaRecuento = Object.freeze({
  Recuento: 0,
  RecuentoYRegularizacion: 1,
});
